import { proxy } from "@/util/proxy.mjs";

export default proxy({
  pageHeaderOverride: null,
});
